import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';

function createData(name, code,address, price, units,Revenue) {
  return { name, code, address, price, units,Revenue };
}
// const [changeColor,setchangeColor]=useState("")
const row ={Balance:'Sep 26, 2023 8:26 AM ET',TDU:"NOR-FX-TDU-6M-FWD-2023-09-26", USD:6000}
 

export default function salesAndBalanceTable() {
  return (
    <TableContainer style={{borderRadius:9}} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead style={{backgroundColor:"Black"}}>
          <TableRow>
            <TableCell align="center" style={{color:"white"}}>Balance</TableCell>
            <TableCell align="center" style={{color:"white"}}>Balance in TDU</TableCell>
            <TableCell align="center" style={{color:"white"}}>Balance in USD</TableCell>
            
            {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
            <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
     
            <TableRow
              key={row.Balance}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell align="center">
                {row.name}Revenue
              </TableCell>
              <TableCell align="center">{row.TDU}</TableCell>
              <TableCell align="center">{row.USD}</TableCell>
        

            </TableRow>
     
        </TableBody>
      </Table>
    </TableContainer>
  );
}